var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBack = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20711 1.95711C9.59763 1.56658 9.59763 0.933418 9.20711 0.542893C8.81658 0.152369 8.18342 0.152369 7.79289 0.542893L1.04289 7.29289C0.652369 7.68342 0.652369 8.31658 1.04289 8.70711L7.79289 15.4571C8.18342 15.8476 8.81658 15.8476 9.20711 15.4571C9.59763 15.0666 9.59763 14.4334 9.20711 14.0429L4.16421 9H18.1351C18.6128 9 19 8.55229 19 8C19 7.44772 18.6128 7 18.1351 7H4.16421L9.20711 1.95711Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/back.4542d9eddd56689eae7d8a12c76fb2a1.svg";